import gql from 'graphql-tag';

export const deletePhotoMutation = gql`
  mutation deletePhoto($individualId: String!) {
    deletePhoto(individualId: $individualId)
  }
`;
